import react from "react";

import Oakley1 from "../images/commercials/Oakley/01OAKLEY Large.jpeg";
import Oakley2 from "../images/commercials/Oakley/02OAKLEY Large.jpeg";
import Oakley3 from "../images/commercials/Oakley/03OAKLEY Large.jpeg";
import Oakley4 from "../images/commercials/Oakley/04OAKLEY Large.jpeg";

const Oakley = () => {
    return (

        <div className="picture-gallery">
            <div className="photo-column">
                <div className="single portrait">
                    <img src={Oakley1} alt="Oakley Commercial Photography - Image 1"/>
                </div>
                <div className="single portrait">
                    <img src={Oakley2} alt="Oakley Commercial Photography - Image 2"/>
                </div>
                <div className="single portrait">
                    <img src={Oakley3} alt="Oakley Commercial Photography - Image 3"/>
                </div>
                <div className="single portrait">
                    <img src={Oakley4} alt="Oakley Commercial Photography - Image 4"/>
                </div>
            </div>
        </div>
    );
}

export default Oakley;